import { useState } from "react";

const btnStyle = {
  position: "absolute",
  top: 8,
  right: 8,
  border: "1px solid #444c56",
  borderRadius: 6,
  padding: "3px 10px",
  fontSize: 12,
  cursor: "pointer",
  color: "#c9d1d9",
  zIndex: 1,
};

function CodeBlock({ code }) {
  const [copied, setCopied] = useState(false);

  function copy() {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <div style={{ position: "relative" }}>
      <button
        onClick={copy}
        style={{ ...btnStyle, background: copied ? "#238636" : "#30363d" }}
      >
        {copied ? "✓ Copiado" : "Copiar"}
      </button>
      <pre><code>{code}</code></pre>
    </div>
  );
}

export default CodeBlock;
